import { AuthService } from '@ff/auth';
import { UserService as _userService } from '@ff/user';
import { Component, OnInit, Input } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { environment } from 'src/environments/environment';
import { SharedService } from '../../../shared/services/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';
import { UserService } from 'src/app/modules/_services/user.service';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';
import { LoaderService } from '@ff/loader';
import { loaderHide, loaderShow } from 'src/app/modules/shared/shared.module';
import { User } from 'src/app/modules/_models/user';
import { Role } from 'src/app/modules/_models/role';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  environment = environment;
  selectedLang;
  expanded = false;
  workspaceExpanded = false;

  languages = [
    { id: 0, value: 'fr', },
    { id: 1, value: 'en' }
  ];

  user: User;

  @Input() public nav: MatSidenav;
  private _user: any;
  constructor(
    public _userService: _userService,
    public userService: UserService,
    public authService: AuthService,
    public _sharedService: SharedService,
    public _translate: TranslateService,
    private router: Router,
    public loaderService: LoaderService
  ) {
    this.selectedLang = this._translate.getDefaultLang();
    this.user = this.userService.getCurrentUser();
    this.userService.initCurrentWorkspace(this.user);
    
    this.setLoaderOnNavigate();
  }

  ngOnInit() {
    
  }


  updateLang(lang) {
    this._translate.use(lang);
    this.userService.updateUserLangPref(lang).then((res) => {
      this._translate.setDefaultLang(lang);
      this._userService._user.next(res.data);
    });
  }

  expand() {
    this.expanded = !this.expanded;
  }

  setLoaderOnNavigate() {
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          loaderShow(this.loaderService);
          break;
        }
        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          loaderHide(this.loaderService);
          break;
        }
        default: {
          break;
        }
      }
    });
  }

}
